<template>
  <v-card flat outlined class="rounded master-card">
    <div class="section-head">Master Data</div>
    <v-card-text class="pa-3">
      <v-select
        v-model="activeTab"
        :items="tabItems"
        item-text="label"
        item-value="value"
        outlined
        dense
        hide-details="auto"
      />

      <v-text-field
        v-model="search"
        placeholder="Search..."
        outlined
        dense
        clearable
        hide-details="auto"
        append-icon="mdi-magnify"
        class="mt-2"
      />

      <div class="master-list mt-2">
        <div v-if="loading" class="empty-state">Loading...</div>
        <div v-else-if="!filteredItems.length" class="empty-state">No results.</div>
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="master-row"
          @click="copyValue(item.value)"
        >
          <span class="master-row__value">{{ item.value }}</span>
          <v-icon x-small color="grey">mdi-content-copy</v-icon>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
      tabItems: [
        { label: "Vehicle Number", value: 0 },
        { label: "Driver License", value: 1 },
        { label: "Container Type", value: 2 },
      ],
      search: "",
      loading: false,
      vehicles: [],
      drivers: [],
      containerTypes: [],
      loaded: { 0: false, 1: false, 2: false },
    };
  },
  computed: {
    items() {
      if (this.activeTab === 0) {
        return this.vehicles.map((v) => ({ id: v.id, value: v.vehicle_number }));
      }
      if (this.activeTab === 1) {
        return this.drivers
          .filter((d) => d.license_number)
          .map((d) => ({ id: d.id, value: d.license_number }));
      }
      return this.containerTypes.map((c) => ({ id: c.id, value: c.type_name }));
    },
    filteredItems() {
      if (!this.search) return this.items;
      const term = this.search.toLowerCase();
      return this.items.filter((item) =>
        (item.value || "").toLowerCase().includes(term)
      );
    },
  },
  watch: {
    activeTab() {
      this.loadTabData();
    },
  },
  methods: {
    loadTabData() {
      if (this.loaded[this.activeTab]) return;
      this.loading = true;

      if (this.activeTab === 0) {
        this.$api.vehicle
          .getVehicleSelectList({ limit: "all" })
          .then((res) => {
            this.vehicles = res.data;
            this.loaded[0] = true;
          })
          .finally(() => (this.loading = false));
      } else if (this.activeTab === 1) {
        this.$api.driver
          .getDriverSelectList({ limit: "all" })
          .then((res) => {
            this.drivers = res.data;
            this.loaded[1] = true;
          })
          .finally(() => (this.loading = false));
      } else {
        this.$api.containerType
          .getContainerTypeSelectList({ limit: "all" })
          .then((res) => {
            this.containerTypes = res.data;
            this.loaded[2] = true;
          })
          .finally(() => (this.loading = false));
      }
    },
    copyValue(value) {
      if (!value) return;
      navigator.clipboard
        .writeText(value)
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: `Copied '${value}'`,
            color: "success",
          });
        })
        .catch(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Could not copy to clipboard.",
            color: "error",
          });
        });
    },
  },
  mounted() {
    this.loadTabData();
  },
};
</script>

<style scoped>
.master-card {
  position: sticky;
  top: 16px;
}
.section-head {
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
  background-color: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.master-list {
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
}
.master-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  cursor: pointer;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.master-row:last-child {
  border-bottom: none;
}
.master-row:hover {
  background-color: #fafafa;
}
.empty-state {
  color: rgba(0, 0, 0, 0.4);
  font-size: 12px;
  padding: 12px;
}
</style>
